import { Component, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import {
  Router,
  NavigationEnd,
  ActivatedRoute,
  Data,
  RouterModule
} from '@angular/router';
import { filter, map, mergeMap } from 'rxjs/operators';
import { CoreService } from '../../../../../../src/app/services/core.service';

import {
  ApexChart,
  ChartComponent,
  ApexDataLabels,
  ApexLegend,
  ApexStroke,
  ApexTooltip,
  ApexAxisChartSeries,
  ApexXAxis,
  ApexYAxis,
  ApexGrid,
  ApexPlotOptions,
  ApexFill,
  ApexMarkers,
  NgApexchartsModule
} from 'ng-apexcharts';


export interface breadcrumbOption {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  yaxis: ApexYAxis;
  xaxis: ApexXAxis;
  fill: ApexFill;
  tooltip: ApexTooltip;
  stroke: ApexStroke;
  legend: ApexLegend;
  grid: ApexGrid;
  marker: ApexMarkers;
}

@Component({
  selector: 'app-breadcrumb',
  standalone: true,
  imports: [NgApexchartsModule, RouterModule],
  templateUrl: './breadcrumb.component.html',
  styleUrls: []
})
export class AppBreadcrumbComponent {
  @ViewChild('chart') chart: ChartComponent = Object.create(null);

  public breadcrumbOption!: Partial<breadcrumbOption> | any;
  public breadcrumb2Option!: Partial<breadcrumbOption> | any;

  // @Input() layout;
  pageInfo: Data | any = Object.create(null);

  options = this.settings.getOptions();

  constructor(
    private settings: CoreService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title
  ) {
    this.breadcrumbOption = {
      series: [
        {
          name: '',
          data: [1.1, 1.4, 1.1, 0.9, 1.9, 1, 0.3, 1.1]
        }
      ],
      chart: {
        type: 'bar',
        height: 35,
        width: 60,
        fontFamily: 'Poppins,sans-serif',
        sparkline: {
          enabled: true
        }
      },
      grid: {
        borderColor: 'rgba(0,0,0,.2)',
        strokeDashArray: 3
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '60%'
        }
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        show: true,
        width: 2,
        colors: ['transparent']
      },
      xaxis: {
        categories: ['Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul']
      },

      legend: {
        show: false
      },
      fill: {
        colors: ['#1e88e5'],
        opacity: 1
      },
      tooltip: {
        enabled: false
      }
    };

    this.breadcrumb2Option = {
      series: [
        {
          name: '',
          data: [1.1, 1.4, 1.1, 0.9, 1.9, 1, 0.3, 1.1]
        }
      ],
      chart: {
        type: 'bar',
        height: 35,
        width: 60,
        fontFamily: 'Poppins,sans-serif',
        sparkline: {
          enabled: true
        }
      },
      grid: {
        borderColor: 'rgba(0,0,0,.2)',
        strokeDashArray: 3
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '60%'
        }
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        show: true,
        width: 2,
        colors: ['transparent']
      },
      xaxis: {
        categories: ['Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul']
      },

      legend: {
        show: false
      },
      fill: {
        colors: ['#26c6da'],
        opacity: 1
      },
      tooltip: {
        enabled: false
      }
    };

    // for breadcrumb
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .pipe(map(() => this.activatedRoute))
      .pipe(
        map((route) => {
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        })
      )
      .pipe(filter((route) => route.outlet === 'primary'))
      .pipe(mergeMap((route) => route.data))
      // tslint:disable-next-line - Disables all
      .subscribe((event) => {
        // tslint:disable-next-line - Disables all
        this.titleService.setTitle(event['title']);
        this.pageInfo = event;
      });

    // Sync on create — breadcrumb mounts after NavigationEnd when leaving dashboard 21/08/2026 DW
    this.syncPageInfoFromRoute();
  }

  private syncPageInfoFromRoute(): void {
    let route = this.activatedRoute;
    while (route.firstChild) {
      route = route.firstChild;
    }
    if (route.outlet !== 'primary') {
      return;
    }
    const data = route.snapshot.data;
    if (data?.['title']) {
      this.titleService.setTitle(data['title']);
    }
    this.pageInfo = data;
  }
}
